import i18n from "i18next";

const getConditions = (row: any) => {
    return row.conditions.map((el: string) => ({value: el, label: i18n.t("condition." + el)}))
}
export {getConditions}